import { render } from "./ClientInfoTab.vue?vue&type=template&id=6d890b4a"
import script from "./ClientInfoTab.vue?vue&type=script&lang=js"
export * from "./ClientInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__